function SmartphoneIcon({
  size = 20,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.83337 2.50016C5.37314 2.50016 5.00004 2.87326 5.00004 3.3335V16.6668C5.00004 17.1271 5.37314 17.5002 5.83337 17.5002H14.1667C14.6269 17.5002 15 17.1271 15 16.6668V3.3335C15 2.87326 14.6269 2.50016 14.1667 2.50016H5.83337ZM3.33337 3.3335C3.33337 1.95278 4.45266 0.833496 5.83337 0.833496H14.1667C15.5474 0.833496 16.6667 1.95278 16.6667 3.3335V16.6668C16.6667 18.0475 15.5474 19.1668 14.1667 19.1668H5.83337C4.45266 19.1668 3.33337 18.0475 3.33337 16.6668V3.3335Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.16663 14.9998C9.16663 14.5396 9.53972 14.1665 9.99996 14.1665H10.0083C10.4685 14.1665 10.8416 14.5396 10.8416 14.9998C10.8416 15.4601 10.4685 15.8332 10.0083 15.8332H9.99996C9.53972 15.8332 9.16663 15.4601 9.16663 14.9998Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default SmartphoneIcon;
